/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function StoryList(props) {
  let renderedStories = [];
  for (let story of props.stories) {
    renderedStories.push(
      <div
        css={css`
          border-bottom: 1px solid black;
          text-align: left;

          &:last-child {
            border: none;
          }
        `}
      >
        <h4
          css={css`
            font-family: ${globals.headlineFont};
            font-size: 14px;
            font-weight: bold;
            margin: 4px 0 0;
          `}
        >
          {story.headline}
        </h4>
        <p
          css={css`
            font-family: ${globals.bodyFont};
            font-size: 11px;
            margin: 4px 0 0;
          `}
        >
          {story.explainer}
        </p>
        <a
          href={story.link}
          target="_blank"
          rel="noopener noreferrer"
          css={css`
            display: block;
            width: 100%;
            text-align: right;
            text-transform: uppercase;
            font-family: ${globals.menuFont};
            font-weight: bold;
            font-size: 11px;
            color: ${globals.DBblue};
            text-decoration: none;
            margin-bottom: 4px;

            &:hover {
              text-decoration: underline;
            }
          `}
        >
          READ THE FULL STORY →
        </a>
      </div>
    );
  }
  return (
    <div
      css={css`
        ${globals.card}
        padding: 0;
      `}
    >
      <div
        css={css`
          height: 27px;
          font-size: 18px;
          line-height: 23px;
          text-transform: uppercase;
          background-color: #000;
          text-align: left;
          font-weight: bold;
          font-family: ${globals.menuFont};
          color: #fff;
          font-size: 18px;
          line-height: 23px;
          padding-top: 1px;
          padding-left: 10px;
        `}
      >
        {props.header}
      </div>
      <div
        css={css`
          padding: 10px;
        `}
      >
        {renderedStories}
      </div>
    </div>
  );
}
